import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PT from 'prop-types';
import {
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import FiltersHeader from '../../components/FiltersHeader';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import TableControls from '../../components/TableControls';
import Link from '../../../lib/components/link';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import {
  selectWeeksNewWithPreSeasonForDropdown,
  selectWeeksWithPreSeasonForDropdown,
} from '../../../store/reducers/season';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { positionToTitle } from '../../../lib/lookups';
import { goToView } from '../../routes.global';
import {
  selectCheatSheet,
  selectCheatSheetsState,
  CHEAT_SHEETS_VIEW,
} from './module/cheatSheets';
import { selectFormulas } from '../../../store/reducers/formula';
import { FormulaType } from '../../../lib/proptypes/formula';
import classes from './cheatSheets.css';
import { goPlayer } from '../Player/module/player';
import injuryIcon from '../../../assets/images/injury-icon.png';
import rookieIcon from '../../../assets/images/icon-rookie.png';
import upsideIcon from '../../../assets/images/upside.png';
import downsideIcon from '../../../assets/images/downside.png';
import analysisIconOld from '../../../assets/images/icon-analysis.png';
import analysisIconUpdated from '../../../assets/images/icon-analysis-updated.png';
import { List } from 'react-content-loader'
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';
import FilterToggle from '../../components/FilterComponents/FilterToggle';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Masonry from 'react-masonry-css';

const pageTitle = 'Fantasy Football Cheat Sheets';

const mapStateToProps = state => {
  const { hasLoaded, year, week, formulaId, rookiesOnly } = selectCheatSheetsState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const loggedIn = state.auth.loggedIn;
  const defaultFormula = state.formulas.defaultFormula;
  var mapfunc = selectWeeksWithPreSeasonForDropdown;
  if ( year >= 2021 ) {
    mapfunc = selectWeeksNewWithPreSeasonForDropdown;
  }
  return {
    defaultFormula,
    hasLoaded,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    rookiesOnly: rookiesOnly,
    toolDescriptions,
    toolsLoaded,
    loggedIn,
    collapsed: selectControlsState(state).collapsed,
    ...hasLoaded && {
      cheatSheet: selectCheatSheet(state),
      weeks: mapfunc(state, year, 'projections'),
      profiles: selectFormulas(state),
    },
  };
};
const actions = {
  goToView,
  goPlayer,
};
export class CheatSheets extends PureComponent {
  static propTypes = {
    weeks: DropdownOptionsType,
    selectedProfile: PT.number,
    selectedWeek: PT.number,
    selectedYear: PT.number,
    cheatSheet: PT.objectOf(PT.arrayOf(PT.shape({
      player_id: PT.number.isRequired,
      fname: PT.string.isRequired,
      lname: PT.string.isRequired,
      team: PT.string.isRequired,
      fpts: PT.number.isRequired,
      bye: PT.number.isRequired,
      rank: PT.number.isRequired,
    }))),
    defaultFormula: PT.number,
    hasLoaded: PT.bool.isRequired,
    collapsed: PT.bool.isRequired,
    goToView: PT.func.isRequired,
    goPlayer: PT.func.isRequired,
    profiles: PT.arrayOf(FormulaType),
    loggedIn: PT.bool.isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
    rookiesOnly: PT.bool.isRequired,
  }

  static defaultProps = {
    weeks: [
      { key: 0, value: 0, text: 'Pre Season' },
    ],
    cheatSheet: null,
    defaultFormula: null,
    selectedProfile: null,
    selectedWeek: null,
    selectedYear: null,
    loggedIn: false,
    rookiesOnly: false,
  }

  state = {
    popupPosition: 'top center',
    touchResize: true,
    prevYear: null,
    prevWeek: null,
    prevProfile: null,
    // for testing, hide all injury data for preseason 2018
    hideInjury: false,
    prevLogin: false,
    didFirst: false,
  }

  /* Tier Names */
  numeralNames = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT']


  changeCheatSheet = () => {
    if (this.props.cheatSheet && typeof window !== 'undefined') {
      let cheatSheet = this.props.cheatSheet;
      let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      cheatSheet = clientWidth >= 985 ? {
        'QB': this.props.cheatSheet['QB'],
        'TE': this.props.cheatSheet['TE'],
        'RB': this.props.cheatSheet['RB'],
        'PK': this.props.cheatSheet['PK'],
        'WR': this.props.cheatSheet['WR'],
        'DF': this.props.cheatSheet['DF']
      } : clientWidth < 605 ? {
        'QB': this.props.cheatSheet['QB'],
        'RB': this.props.cheatSheet['RB'],
        'WR': this.props.cheatSheet['WR'],
        'TE': this.props.cheatSheet['TE'],
        'PK': this.props.cheatSheet['PK'],
        'DF': this.props.cheatSheet['DF'],
      } : {
        'QB': this.props.cheatSheet['QB'],
        'WR': this.props.cheatSheet['WR'],
        'PK': this.props.cheatSheet['PK'],
        'RB': this.props.cheatSheet['RB'],
        'TE': this.props.cheatSheet['TE'],
        'DF': this.props.cheatSheet['DF']
      }
      this.setState({touchResize: !this.state.touchResize});
    }
  }

  changeCombinedCheatSheet = () => {
    if (typeof window !== 'undefined') {
      let cheatSheet = this.props.cheatSheet;
      let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      cheatSheet = clientWidth >= 985 ? {
        'QB': this.props.cheatSheet['QB'],
        'PK': this.props.cheatSheet['PK'],
        'RB': this.props.cheatSheet['RB'],
        'DF': this.props.cheatSheet['DF'],
        'WR/TE': this.props.cheatSheet['WR/TE']
      } : clientWidth < 605 ? {
        'QB': this.props.cheatSheet['QB'],
        'RB': this.props.cheatSheet['RB'],
        'WR/TE': this.props.cheatSheet['WR/TE'],
        'PK': this.props.cheatSheet['PK'],
        'DF': this.props.cheatSheet['DF'],
      } : {
        'QB': this.props.cheatSheet['QB'],
        'WR/TE': this.props.cheatSheet['WR/TE'],
        'RB': this.props.cheatSheet['RB'],
        'PK': this.props.cheatSheet['PK'],
        'DF': this.props.cheatSheet['DF'],
      }
      this.setState({touchResize: !this.state.touchResize});
    }
  }

  componentWillMount() {
    this.tableContainer = [];
    /*
    this.setState({
      prevYear: this.props.selectedYear,
      prevWeek: this.props.selectedWeek,
      prevProfile: this.props.selectedProfile
    });
    */
  }
  /*
   componentWillUpdate() {

    if (this.props.selectedYear !== this.state.prevYear ||
      this.props.selectedWeek !== this.state.prevWeek ||
      this.props.selectedProfile !== this.state.prevProfile) {
      window.location.reload();
    }

  }
  */
  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
    window.removeEventListener('resize', this.changeCombinedCheatSheet.bind(this));
    window.removeEventListener('resize', this.changeCheatSheet.bind(this));
    let combined = this.props.profiles ? (this.props.profiles
      .find(profile => profile.id === this.props.selectedProfile).combine || 0) : undefined;
    combined === 1 ? window.addEventListener('resize', this.changeCombinedCheatSheet.bind(this)) : window.addEventListener('resize', this.changeCheatSheet.bind(this));
    this.setState({ didFirst: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      const { selectedYear, defaultFormula } = this.props;
      this.setState({ prevLogin: prevProps.loggedIn });
      this.props.goToView(
        CHEAT_SHEETS_VIEW, {
          query: { year: selectedYear, formulaId: defaultFormula }
        },
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.changeCombinedCheatSheet.bind(this));
    window.removeEventListener('resize', this.changeCheatSheet.bind(this));
  }

  toggleRookies = () => {
    this.props.goToView(CHEAT_SHEETS_VIEW, { query: { rookiesOnly: !this.props.rookiesOnly } });
  }
  shouldEnableToggle = (week) => {
    if (week > 0)
      return false;
    else
      return true;
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedProfile } = this.props;
    if (selectedYear !== value) {
      this.props.goToView(
        CHEAT_SHEETS_VIEW,
        {
          query: { year: value, formulaId: selectedProfile },
          updateQuery: false,
        },
      );
    }
  }

  handleChangeTimeFrame = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(CHEAT_SHEETS_VIEW, { query: { week: value } });
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(CHEAT_SHEETS_VIEW, { query: { formulaId: value } });
    }
  }

  getElementHeight = (el) => {
    return el && parseInt(window.getComputedStyle(el, null).getPropertyValue('height'));
  }
  checkTableHeight = () => {
    let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (this.tableContainer[0] && this.tableContainer[1] && this.tableContainer[2]) {
      let height = [this.getElementHeight(this.tableContainer[0]), this.getElementHeight(this.tableContainer[1]), this.getElementHeight(this.tableContainer[2])];
      if (clientWidth >= 1000) {
        this.tableContainer[1].style.height = height[0] + height[1] < height[2]/2 ? height[1] + height[2]/2 - height[0] + 'px' : height[1] + 'px';
      }
    } else if (this.tableContainer[1]) {
      this.tableContainer[1].style.height = 'auto';
    }
  }
   setTableRef = el => {
    // to ckeck if it's KICKERS
    if (el) {
      switch (el.getElementsByClassName('table-title')[0].innerHTML) {
        case 'QUARTERBACKS': this.tableContainer[0] = el; break;
        case 'KICKERS': this.tableContainer[1] = el; break;
        case 'WIDE RECEIVERS + TIGHT ENDS': this.tableContainer[2] = el; break;
      }
    }
    this.tableContainer.length === 3 && this.checkTableHeight();
  }

  setPopupPosition = (e) => {
    var top = e.target.offsetTop;
    var cur = e.target.offsetParent;
    while(cur !== null){
      top += cur.offsetTop;
      cur = cur.offsetParent;
    }
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    this.setState({ popupPosition: (top - scrollTop) > parseInt(clientHeight/2) ? 'top center' : 'bottom center' });
  }

  renderPlayerRow = ({ player_id: id, rank, fpts, fname, lname, team, bye, writeup, update_date, injured, injury_type, opponent, rookie, upside, downside }) => {

    const name = `${fname} ${lname}`;
    let analysisIcon = analysisIconUpdated;
    const freshnessCheck = update_date => {
      // Check if analysis was updated in past 24 hours
      let timenow = new Date().getTime() / 1000;
      analysisIcon = ((timenow - update_date) < 86400) ? analysisIconUpdated : analysisIconOld;
      return analysisIcon;
    }

    let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{`${rank}.`}</Table.Cell>
        <Table.Cell textAlign="center">{fpts}</Table.Cell>
        <Table.Cell textAlign="center" className={classes.playerCell}>

            <Link
              to={goPlayer(id, `${fname}-${lname}`)}
              className={classes.playerName}
            >
              <div className={classes.nameIndi}>
                <span className={classes.nameAlign}>{fname}&nbsp;</span>
                <div className={classes.nameIndi2}>
                  <span className={classes.nameAlign}>{lname}</span>
                  {rookie==="Y" ? <img src={rookieIcon} alt="" className={classes.rookieIcon} /> : ""}

                  {upside==="Y" ? <img src={upsideIcon} alt="" className={classes.upsideIcon} /> : ""}

                  {downside==="Y" ? <img src={downsideIcon} alt="" className={classes.downsideIcon} /> : ""}
                </div>
              </div>
            </Link>

          {writeup
            ? <Popup
            // for testing, hide all injury data and icon
              trigger={<a role="button" onClick={this.setPopupPosition}>{this.state.hideInjury ? <img src={freshnessCheck(update_date)} alt="" className={classes.analysisIcon} /> : injured ? <img src={injuryIcon} alt="" className={classes.injuryIcon} /> : <img src={freshnessCheck(update_date)} alt="" className={classes.analysisIcon} />}</a>}
              header={this.state.hideInjury ? `${name} Analysis` : injured ? `${name} Injury report` : `${name} Analysis`}
              content={ReactHtmlParser(this.state.hideInjury ? writeup : injured ? injury_type : writeup)}
              position={this.state.popupPosition}
              wide
              on={['hover', 'click']}
              hideOnScroll
              hoverable={clientWidth < 450 ? false : true}
              className={classes.analysisPopup}
              />
            : ""
          }
        </Table.Cell>
        <Table.Cell textAlign="center">{team}</Table.Cell>
        { this.props.selectedWeek < 1
          ? <Table.Cell textAlign="center">{bye}</Table.Cell>
          : <Table.Cell textAlign="center">{opponent}</Table.Cell>
        }
      </Table.Row>
    );
  }

  renderTier = (tier, players) => {
    const playersByTier = players.filter(player => player.tier === tier);

    return (
      <fØ>
        { /* <Table.Row>
          <Table.Cell className="secondary-header" textAlign="center" colSpan="5">TIER {this.numeralNames[tier]}</Table.Cell>
        </Table.Row> */ }

        {playersByTier.map(player => this.renderPlayerRow(player))}
        </fØ>
    );
  }

  renderPositionTable = players => {
    const maxTier = players[players.length - 1].tier;
    const tiers = [];
    for (let i = 0; i < maxTier; i++) tiers.push(i + 1);

    const wrapperClass = classNames(
      classes.positionTable,
      { [classes.collapsed]: this.props.collapsed },
    );

    const combinedWRTE = this.props.profiles
      .find(profile => profile.id === this.props.selectedProfile).combine || undefined;

    const playerPosition = players[0].position === 'WR' && combinedWRTE ? 'wr,te' : players[0].position;

    return (
      <div className={wrapperClass} key={playerPosition} ref={combinedWRTE ? this.setTableRef : null}>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="table-title" colSpan="5" textAlign="center">
                {positionToTitle(playerPosition, { plural: true, uppercase: true })}
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign="center" className={classes.rankHeader}>Rk</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className={classes.ffptsHeader}>FF Pts</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Player</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Team</Table.HeaderCell>
              { this.props.selectedWeek < 1
                ? <Table.HeaderCell textAlign="center" className={classes.byeHeader}>Bye</Table.HeaderCell>
                : <Table.HeaderCell textAlign="center" className={classes.byeHeader}>Opp</Table.HeaderCell>
              }
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tiers.map(tier => this.renderTier(tier, players))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render = () => {
    const {
      selectedYear,
      selectedWeek,
      selectedProfile,
      weeks,
      hasLoaded,
      toolDescriptions,
      toolsLoaded,
      rookiesOnly,
    } = this.props;

    var {cheatSheet} = this.props;
    let printLink = '';

    const hasData = !!(cheatSheet && typeof window !== 'undefined' && Object.values(cheatSheet)[0].length);

    let combined = this.props.profiles ? (this.props.profiles
      .find(profile => profile.id === this.props.selectedProfile).combine || 0) : undefined;

    let clientWidth = null;

    if (typeof combined !== 'undefined' && typeof window !== 'undefined') {
      let cheatSheet = this.props.cheatSheet;
      clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      if (combined === 1) {
        cheatSheet = clientWidth >= 985 ? {
          'QB': this.props.cheatSheet['QB'],
          'PK': this.props.cheatSheet['PK'],
          'RB': this.props.cheatSheet['RB'],
          'DF': this.props.cheatSheet['DF'],
          'WR/TE': this.props.cheatSheet['WR/TE']
        } : clientWidth < 605 ? {
          'QB': this.props.cheatSheet['QB'],
          'RB': this.props.cheatSheet['RB'],
          'WR/TE': this.props.cheatSheet['WR/TE'],
          'PK': this.props.cheatSheet['PK'],
          'DF': this.props.cheatSheet['DF'],
        } : {
          'QB': this.props.cheatSheet['QB'],
          'WR/TE': this.props.cheatSheet['WR/TE'],
          'RB': this.props.cheatSheet['RB'],
          'PK': this.props.cheatSheet['PK'],
          'DF': this.props.cheatSheet['DF'],
        }
      } else {
        cheatSheet = clientWidth >= 985 ? {
          'QB': this.props.cheatSheet['QB'],
          'TE': this.props.cheatSheet['TE'],
          'RB': this.props.cheatSheet['RB'],
          'PK': this.props.cheatSheet['PK'],
          'WR': this.props.cheatSheet['WR'],
          'DF': this.props.cheatSheet['DF']
        } : clientWidth < 605 ? {
          'QB': this.props.cheatSheet['QB'],
          'RB': this.props.cheatSheet['RB'],
          'WR': this.props.cheatSheet['WR'],
          'TE': this.props.cheatSheet['TE'],
          'PK': this.props.cheatSheet['PK'],
          'DF': this.props.cheatSheet['DF'],
        } : {
          'QB': this.props.cheatSheet['QB'],
          'WR': this.props.cheatSheet['WR'],
          'PK': this.props.cheatSheet['PK'],
          'RB': this.props.cheatSheet['RB'],
          'TE': this.props.cheatSheet['TE'],
          'DF': this.props.cheatSheet['DF']
        }
      }
    }

    if (hasData) {
      printLink = location.href.split('/');
      printLink.length = 3; // just need http://xxx.com
      printLink = printLink.join('/') + '/cheatsheets/' + selectedYear + '/' + selectedWeek + '/' + selectedProfile + '/' + rookiesOnly + '/print';
    }

    // for testing, hide injury data and icon
    this.setState({ hideInjury: true });

    // Masonry Columns Breakpoints
    const breakpointColumns = {
      default: 3,
      999: 2,
      619: 1,
    };

    return (
      <div className={classes.wrapper} onTouchStart={""} >
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.cheatsheets.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.cheatsheets.text}
            />)}
          seasonType={selectedWeek === 0 ? 'preseasons' : 'seasons'}
          statType="projections"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
          stacked
          printLink={clientWidth && clientWidth > 350 ? printLink : null}
        >
          <PrimaryDropdown
            label="Timeframe:"
            activeItem={selectedWeek}
            onChange={this.handleChangeTimeFrame}
            choices={weeks}
            className={classes.singleDropdown}
          />
          {this.shouldEnableToggle(selectedWeek) &&
          <FilterToggle
            label={''}
            checked={rookiesOnly}
            valueOff={'All Players'}
            valueOn={'Rookies Only'}
            onChange={this.toggleRookies}
          />}
        </FiltersHeader>

        <TableControls injury={this.state.hideInjury ? false : true} hideInjury={this.state.hideInjury ? true : false} playerStatus colGroups={[{ columns: ['RK', 'FFPTS', 'player', 'team', 'bye', 'opponent_team_abbr'] }]} />
        <Masonry
          breakpointCols={breakpointColumns}
          className={classes.tablesWrapper}
          columnClassName={classes.tablesWrapperColumn}
        >
            {hasLoaded && hasData && Object.values(cheatSheet).map(position =>
              position && position.length ? this.renderPositionTable(position) : null,
            )}
        </Masonry>

        {hasLoaded && !hasData && <List />}

      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(CheatSheets);



// WEBPACK FOOTER //
// ./src/app/views/CheatSheets/CheatSheets.js